import { format, formatDistance, parseISO } from 'date-fns';
import { ptBR as locale } from 'date-fns/locale';

export default class DateHelper {
  static toDateObject(date) {
    return date instanceof Date ? date : parseISO(date);
  }

  static toFormatString(date, formatString = 'dd/MM/yyyy') {
    if (!date) {
      return '';
    }

    return format(this.toDateObject(date), formatString, { locale });
  }

  static toHowLongString(date) {
    if (!date) {
      return '';
    }

    return formatDistance(this.toDateObject(date), new Date(), { locale });
  }
}
